"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntercom = _interopRequireDefault(require("react-intercom"));

var _ajax = require("../actions/ajax");

var _httpActions = require("../actions/http-actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Intercom = function Intercom(_ref) {
  var appId = _ref.appId,
      identityUuid = _ref.identityUuid,
      email = _ref.email,
      fullName = _ref.fullName;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      userHash = _useState2[0],
      setUserHash = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!userHash && identityUuid) {
      (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _ajax.axios.get("".concat((0, _httpActions.baseUrl)(), "/chat-rest/v1/c1/user_hash/"));

              case 2:
                result = _context.sent;
                setUserHash(result.data.user_hash);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, [userHash, identityUuid]);
  return userHash ? /*#__PURE__*/_react.default.createElement(_reactIntercom.default, {
    appID: appId,
    user_id: identityUuid,
    user_hash: userHash,
    email: email,
    name: fullName
  }) : /*#__PURE__*/_react.default.createElement(_reactIntercom.default, {
    appID: appId
  });
};

Intercom.propTypes = {
  appId: _propTypes.default.string.isRequired,
  identityUuid: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  fullName: _propTypes.default.string.isRequired
};
var _default = Intercom;
exports.default = _default;